import { render, staticRenderFns } from "./RemindersTable.vue?vue&type=template&id=87659f7a&scoped=true&"
import script from "./RemindersTable.vue?vue&type=script&lang=js&"
export * from "./RemindersTable.vue?vue&type=script&lang=js&"
import style0 from "./RemindersTable.vue?vue&type=style&index=0&id=87659f7a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87659f7a",
  null
  
)

export default component.exports